import React, { Suspense, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import useUser from "hooks/useUser";
import { userHasPermissions } from "services/authUtil";
import TalaeraSpinner from "./../TalaeraSpinner/TalaeraSpinner";
import TalaeraRoutes from "./TalaeraRoutes";
import { useParams } from "react-router";
import { ForbiddenPage } from "pages/Error/ForbiddenPage";

export default function PrivateRoute(props) {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    loading: props.loading ? props.loading : false,
    hasPermissions: false,
  });
  const user = useUser();

  useEffect(() => {
    if (props.permissions && typeof props.permissions === "function") {
      const permissions = props.permissions(props);
      if (typeof permissions === "function") {
        permissions(
          params,
          resp => {
            setState({ loading: false, hasPermissions: resp });
          },
          () => {
            setState({ loading: false, hasPermissions: false });
          }
        );
      } else {
        setState({ loading: false, hasPermissions: permissions });
      }
    }
    // eslint-disable-next-line
  }, [params, props.permissions]);

  const { component, ...rest } = props;

  if (state.loading) {
    return <TalaeraSpinner />;
  }

  if (user) {
    let hasPermissions = false;

    if (rest.permissions) {
      switch (typeof rest.permissions) {
        case "object":
          if (rest.permissions instanceof Array) {
            hasPermissions = userHasPermissions(rest.permissions);
          }
          break;
        case "string":
          hasPermissions = userHasPermissions([rest.permissions]);
          break;
        case "function":
          hasPermissions = state.hasPermissions;
          break;
        default:
      }
    }
    if (hasPermissions) {
      return (
        <Suspense
          fallback={
            <div>
              <TalaeraSpinner />
            </div>
          }
        >
          {React.createElement(component, { ...rest, params, location, navigate })}
        </Suspense>
      );
    } else if (rest.ifNotAllowed) {
      return rest.ifNotAllowed;
    } else {
      return <ForbiddenPage />;
    }
  } else {
    return (
      <Navigate
        to={{
          pathname: TalaeraRoutes.SIGN_IN.path,
          state: { from: location, modal: true },
        }}
        replace
      />
    );
  }
}
